import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";
import Button from "@mui/material/Button";

export default function CustomButton({ props, dark, text }) {
  return (
    <Button
      variant="contained"
      endIcon={<ArrowForwardIosRoundedIcon />}
      sx={
        dark
          ? [
              {
                color: "primary.main",
                background: "#fff",
              },
              (theme) => ({
                "&:hover": {
                  background: theme.palette.primary.dark,
                  color: "#fff",
                },
              }),
            ]
          : []
      }
      {...props}
    >
      {text}
    </Button>
  );
}
